<template>
    <div class="bg-white px-3 index">
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines u-f u-jsb" :inline="true">
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">新增
                        </el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="success" icon="el-icon-potato-strips" size="small" :loading='uploading'
                            @click="updatelist">更新PC首页</el-button>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item>
                        <el-button type="primary" size="small" :loading='uploading' @click="setSeoPc(22)">PC首页配置
                        </el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="small" :loading='uploading' @click="setSeoPc(21)">PC列表页配置
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" :height="height" row-key="id" border
                :tree-props="{children: 'child'}">
                <el-table-column prop="id" label="编号"></el-table-column>
                <el-table-column prop="name" label="类别"></el-table-column>
                <el-table-column prop="sort" label="排序"></el-table-column>
                <el-table-column prop="create_time" label="添加时间" show-overflow-tooltip></el-table-column>
                <el-table-column prop="add_by" label="添加人"></el-table-column>
                <el-table-column prop="add_by" label="更新分类内容">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-potato-strips" size="mini" :loading='uploading'
                            @click="updatelistsing(scope.row)">更新</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" v-if="scope.row.hide==0" @click="handlehide(scope.row,1)">隐藏</el-button>
                        <el-button size="mini" v-else type="info" @click="handlehide(scope.row,0)">显示</el-button>
                        <el-button size="mini" type="primary" icon="el-icon-edit-outline"
                            @click="handleEdit(scope.row,scope.$index)"></el-button>
                        <el-button size="mini" type="danger" icon="el-icon-delete"
                            @click="handleDelet(scope.row,scope.$index)"></el-button>
                    </template>
                </el-table-column>
            </el-table>

        </div>
        <el-dialog title="类别设置" :visible.sync="dialogVisible" center width="40%" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px" class="demo-ruleForm">
                    <el-form-item label="上级类别名称" prop='sz_type'>
                        <el-select v-model="ruleForm.sz_type" placeholder="请选择" size="small">
                            <el-option v-for="item in lb_options" :key="item.id"
                                :label="item.name_2?item.name_2:item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="类别名称" prop='sz_name'>
                        <el-input v-model="ruleForm.sz_name" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="排序">
                        <el-input v-model="ruleForm.sz_sort" size="small" type="number"> </el-input>
                    </el-form-item>
                    <el-form-item label="标题">
                        <el-input v-model="ruleForm.seo_title" size="small" type="text"> </el-input>
                    </el-form-item>
                    <el-form-item label="关键词">
                        <el-input v-model="ruleForm.seo_keyword" size="small" type="text"> </el-input>
                    </el-form-item>
                    <el-form-item label="描述">
                        <el-input v-model="ruleForm.seo_describe" size="small" type="textarea" :rows="2"> </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
        <!-- seo配置 -->
        <el-dialog :title="seotype==21?'列表seo配置':'首页seo配置'" :visible.sync="seoVisible" center width="40%"
            class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="homeseo" :rules="seorule" ref="homeseo" label-width="150px" class="demo-ruleForm">
                    <el-form-item label="标题" prop="seo_title">
                        <el-input v-model="homeseo.seo_title" size="small" type="text"> </el-input>
                    </el-form-item>
                    <el-form-item label="关键词" prop="seo_keywords">
                        <el-input v-model="homeseo.seo_keywords" size="small" type="text"> </el-input>
                    </el-form-item>
                    <el-form-item label="描述" prop="seo_description">
                        <el-input v-model="homeseo.seo_description" size="small" type="textarea" :rows="2"> </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="seosubmit('homeseo')" size="small" type="primary" :loading="subloading">提 交
                </el-button>
                <el-button @click="seoVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
        <el-dialog title="更新类型" :visible.sync="updateVisible" center width="40%">
            <div class="dialog-ibox-content">
                <el-form ref="updatepcrule" label-width="150px" class="demo-ruleForm">
                    <el-form-item label="更新类型">
                        <el-radio-group v-model="updatetype">
                            <el-radio :label="1">图文</el-radio>
                            <el-radio :label="2">视频</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submitupdatePC()" size="small" type="primary" :loading="subloading">提 交</el-button>
                <el-button @click="updateVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>

    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                loading: false,
                tableData: [],
                lb_options: [],
                currentPage: 1,
                pagesize: 15,
                height: null,
                // 
                eid: '0',
                dialogVisible: false,
                subloading: false,
                ruleForm: {
                    sz_type: '',
                    sz_name: '',
                    sz_sort: 50,
                    seo_describe: '',
                    seo_keyword: '',
                    seo_title: '',
                },
                rule: {
                    sz_name: [{
                        required: true,
                        message: '请填写类别名称',
                        trigger: 'blur'
                    }],
                },
                uploading: false,
                updateVisible: false,
                updatetype: 1,
                updatetype_id: 0,
                homeseo: {
                    seo_description: '',
                    seo_keywords: '',
                    seo_title: '',
                },
                seorule: {
                    seo_description: [{
                        required: true,
                        message: '不能为空',
                        trigger: 'blur'
                    }],
                    seo_keywords: [{
                        required: true,
                        message: '不能为空',
                        trigger: 'blur'
                    }],
                    seo_title: [{
                        required: true,
                        message: '不能为空',
                        trigger: 'blur'
                    }],
                },
                seotype: 0,
                seoVisible: false,

            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            that.gettype()
            that.begin()
        },
        methods: {
            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 175 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.height = window.innerHeight - titles - 175 + 'px'
                }
            },
            //下拉框
            gettype() {
                let that = this
                that.lb_options = []
                axios.post("/admin/healthCategory/categorySelect", {}, {
                        token: true
                    })
                    .then(response => {
                        var arr = [{
                            id: 0,
                            name_2: '顶级类别'
                        }]
                        that.lb_options = arr.concat(response.data.data)
                        this.ruleForm.sz_type = 0
                    })
            },
            // 搜索
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.tableData = []
                that.loading = true
                axios.post("/admin/healthCategory/categoryHead", {}, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            handleAdd() {
                let that = this
                that.dialogVisible = true
                that.eid = '0'
                that.form_clear()
            },
            form_clear() {
                let that = this
                that.ruleForm.sz_name = ''
                that.ruleForm.sz_sort = 50
                that.ruleForm.seo_title = ''
                that.ruleForm.seo_keyword = ''
                that.ruleForm.seo_describe = ''


            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        that.subloading = true
                        let urls;
                        if (this.eid && this.eid != '0') {
                            urls = "/admin/healthCategory/update"
                        } else {
                            urls = "/admin/healthCategory/save"
                        }
                        axios.post(urls, {
                                id: that.eid,
                                name: that.ruleForm.sz_name,
                                author: this.user.id,
                                pid: this.ruleForm.sz_type,
                                sort: that.ruleForm.sz_sort,
                                seo_title: that.ruleForm.seo_title,
                                seo_keyword: that.ruleForm.seo_keyword,
                                seo_describe: that.ruleForm.seo_describe,
                            }, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.code == '200') {
                                    that.dialogVisible = false
                                    that.search()
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                that.subloading = false
                            })
                    } else {
                        return false;
                    }
                });
            },
            handlehide(row, t) {
                let that=this
                let urls="/admin/healthCategory/update"
                axios.post(urls, {
                        id: row.id,
                        name: row.name,
                        author: this.user.id,
                        pid: row.pid,
                        hide:t
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.subloading = false
                        if (response.data.code == '200') {
                            row.hide=t
                        } else {
                            that.$message.error(response.data.msg);
                        }
                    })
                    .catch(error => {
                        that.subloading = false
                    })
            },
            // 编辑
            handleEdit(row, index) {
                let that = this
                that.form_clear()
                that.dialogVisible = true
                that.eid = row.id
                axios
                    .post("/admin/healthCategory/read", {
                        id: that.eid,
                        author: this.user.id,
                        name: that.ruleForm.sz_name,
                        pid: this.ruleForm.sz_type,

                    }, {
                        token: true
                    })
                    .then(response => {
                        var data = response.data.data
                        that.ruleForm.sz_name = data.name
                        that.ruleForm.sz_type = data.pid
                        that.ruleForm.sz_sort = data.sort
                        that.ruleForm.seo_title = data.seo_title
                        that.ruleForm.seo_keyword = data.seo_keyword
                        that.ruleForm.seo_describe = data.seo_describe
                    })
                    .catch(error => {})
            },
            // 删除
            handleDelet(row, index) {
                let that = this
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/healthCategory/del", {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.search()
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            updatelist() {
                let that = this
                this.$confirm('此操作将更新pc端首页, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.uploading = true
                    axios
                        .get("/admin/h5/createStaticHtml?source=3&time=0", {
                            headers: {
                                token: sessionStorage.getItem('token')
                            }
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '更新成功!'
                                });
                            } else {
                                that.$message.error(response.data.msg);
                            }
                            this.uploading = false
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            updatelistsing(row) {
                this.updatetype_id = row.id
                this.updatetype = 1
                this.updateVisible = true
            },
            submitupdatePC() {
                this.subloading = true
                axios
                    .get(
                        `/admin/pc/createStaticHtml?source=1&type=${this.updatetype}&page=1&time=0&top_category_id=${this.updatetype_id}`, {
                            headers: {
                                token: sessionStorage.getItem('token')
                            }
                        })
                    .then(response => {
                        if (response.data.code == '200') {
                            this.$message({
                                type: 'success',
                                message: '更新成功!'
                            });
                            this.updateVisible = false
                        } else {
                            that.$message.error(response.data.msg);
                        }
                        this.subloading = false
                    })
                    .catch(error => {})
            },
            setSeoPc(type) {
                this.seotype = type
                axios
                    .get(
                        `/admin/sysconfig?id=${this.seotype}`, {
                            headers: {
                                token: sessionStorage.getItem('token')
                            }
                        })
                    .then(res => {
                        this.homeseo = res.data.data.value
                    })
                    .catch(error => {})
                this.seoVisible = true

            },
            seosubmit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        that.subloading = true
                        let urls =
                            `/admin/pc/setSeoConfig `
                        axios.post(urls, {
                                id: this.seotype,
                                value: {
                                    seo_title: this.homeseo.seo_title,
                                    seo_keywords: this.homeseo.seo_keywords,
                                    seo_description: this.homeseo.seo_description,
                                }
                            }, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.code == '200') {
                                    this.$message({
                                        type: 'success',
                                        message: '更新成功!'
                                    });
                                    that.seoVisible = false
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                that.subloading = false
                            })
                    } else {
                        return false;
                    }
                });
            }
        },

    };
</script>


<style scoped>
</style>